import React from 'react';
import drArpana from '../../assets/images/dr-arpana.jpg';
import drDeepal from '../../assets/images/dr-deepak.jpg';

const doctors = [
  {
    name: 'Dr. Arpana Raj',
    photo: drArpana,
    degree: 'B.H.M.S.',
    title: 'Homoeopathic Physician',
    specialization: 'Female & Infertility Specialist',
    exp: '10+ Years',
    bio: 'Dr. Arpana Raj is a dedicated homoeopathic physician specializing in female health and infertility. Her compassionate approach and deep knowledge of classical homeopathy have helped thousands of patients achieve lasting wellness. She believes in curing the disease, not palliating.',
    tags: ["Women's Health", 'Infertility', 'Chronic Diseases', 'Child Healthcare'],
  },
  {
    name: 'Dr. Deepak Kapoor',
    photo: drDeepal,
    degree: 'B.H.M.S.',
    title: 'Homoeopathic Physician',
    specialization: 'Chronic & Complex Disease Specialist',
    exp: '15+ Years',
    bio: 'He especially specializes in all kinds of pain management and believes in curing the disease, not palliating. He has vast experience in treating thousands of patients belonging to different diseases in different locations of India.',
    tags: ['Chronic Diseases', 'Skin Disorders', 'Stress & Anxiety', 'Digestive Disorders', 'Orthopaedic', 'Pain Management', 'Endocrine Disorder', 'Hair Problems', 'Neurological Problems', 'Kidney Disease', 'Stress & Mental Disorder'],
  },
];

export default function AboutSection() {
  return (
    <section id="about" style={{
      padding: 'clamp(3rem, 8vw, 6rem) clamp(1.5rem, 5vw, 6rem)',
      background: 'linear-gradient(135deg, #f5f0e8, #eaf2ea)',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
        <p style={{ color: 'var(--gold)', letterSpacing: '3px', fontSize: '0.85rem', textTransform: 'uppercase', marginBottom: '0.5rem' }}>Meet Our Doctors</p>
        <h2 className="section-title">Our Expert Team</h2>
        <p className="section-subtitle">Dedicated to your holistic healing journey</p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '3rem', maxWidth: '1000px', margin: '0 auto'
      }}>
        {doctors.map((doc, i) => (
          <div key={i} style={{
            background: 'white', borderRadius: '24px',
            overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
            transition: 'transform 0.3s ease',
          }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ position: 'relative', height: '320px', overflow: 'hidden' }}>
              <img src={doc.photo} alt={doc.name} style={{
                width: '100%', height: '100%',
                objectFit: 'cover', objectPosition: 'top',
                transition: 'transform 0.4s ease'
              }}
                onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.target.style.transform = 'scale(1)'}
              />
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'linear-gradient(transparent, rgba(74,122,80,0.92))',
                padding: '2rem 1.5rem 1rem',
              }}>
                <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.6rem', color: 'white', fontWeight: 700, marginBottom: '0.2rem' }}>{doc.name}</h3>
                <p style={{ fontFamily: 'Jost', fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)' }}>{doc.degree} • {doc.title}</p>
              </div>
            </div>

            <div style={{ padding: '1.5rem' }}>
              <div style={{
                display: 'inline-block',
                background: 'rgba(201,168,76,0.15)', color: 'var(--gold)',
                border: '1px solid rgba(201,168,76,0.3)',
                padding: '0.3rem 1rem', borderRadius: '20px',
                fontSize: '0.82rem', fontFamily: 'Jost',
                marginBottom: '0.8rem', fontWeight: 500
              }}>⭐ {doc.specialization}</div>

              <div style={{
                display: 'inline-block', marginLeft: '0.5rem',
                background: 'rgba(122,158,126,0.12)', color: 'var(--sage-dark)',
                border: '1px solid var(--sage-light)',
                padding: '0.3rem 1rem', borderRadius: '20px',
                fontSize: '0.82rem', fontFamily: 'Jost',
                marginBottom: '0.8rem'
              }}>🕐 {doc.exp} Experience</div>

              <p style={{ fontFamily: 'Jost', fontSize: '0.92rem', color: 'var(--text-mid)', lineHeight: 1.8, marginBottom: '1.2rem' }}>{doc.bio}</p>

              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                {doc.tags.map(tag => (
                  <span key={tag} style={{
                    background: 'rgba(122,158,126,0.12)', color: 'var(--sage-dark)',
                    padding: '0.3rem 0.8rem', borderRadius: '20px',
                    fontSize: '0.78rem', fontFamily: 'Jost',
                    border: '1px solid var(--sage-light)'
                  }}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{
        maxWidth: '1000px', margin: '4rem auto 0',
        background: 'white', borderRadius: '24px',
        padding: '2.5rem', boxShadow: '0 10px 40px rgba(0,0,0,0.07)'
      }}>
        <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', color: 'var(--sage-dark)', textAlign: 'center', marginBottom: '2rem' }}>
          We Specialize In
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem' }}>
          {[
            ['🦠', 'Chronic Diseases'],
            ['🤧', 'Allergies'],
            ['🧴', 'Skin Disorders'],
            ['👶', 'Child Healthcare'],
            ['🧠', 'Stress & Anxiety'],
            ['🫃', 'Digestive Disorders'],
            ['👩', "Women's Health"],
            ['🌸', 'Infertility'],
          ].map(([icon, label]) => (
            <div key={label} style={{
              display: 'flex', alignItems: 'center', gap: '0.8rem',
              padding: '0.8rem 1rem', borderRadius: '12px',
              background: 'rgba(122,158,126,0.06)',
              border: '1px solid rgba(122,158,126,0.15)'
            }}>
              <span style={{ fontSize: '1.3rem' }}>{icon}</span>
              <span style={{ fontFamily: 'Jost', fontSize: '0.88rem', color: 'var(--text-dark)' }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{
        maxWidth: '1000px', margin: '2rem auto 0',
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '1rem'
      }}>
        {[
          ['✅', 'No Side Effects'],
          ['🌿', 'Natural Healing'],
          ['👤', 'Personalized Care'],
          ['🏆', 'Trusted Homeopathy'],
        ].map(([icon, label]) => (
          <div key={label} style={{
            textAlign: 'center', padding: '1rem',
            background: 'rgba(201,168,76,0.08)',
            borderRadius: '12px', border: '1px solid rgba(201,168,76,0.2)'
          }}>
            <div style={{ fontSize: '1.5rem', marginBottom: '0.4rem' }}>{icon}</div>
            <div style={{ fontFamily: 'Jost', fontSize: '0.85rem', color: 'var(--sage-dark)', fontWeight: 500 }}>{label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
